
import FindPartner from "../../components/landing/search-on-tinder/find-partner";
import QuotesBlock from "../../components/landing/search-on-tinder/quotes-block";
import blog from "../../components/landing/blog";
import ServiceFor from "../../components/landing/search-on-tinder/service-for";
import HowWeDo from "../../components/landing/search-on-tinder/how-we-do";
import SitesScan from "../../components/landing/search-on-tinder/sites-scan";
import Waiting from "../../components/landing/search-on-tinder/waiting";
import Results from "../../components/landing/search-on-tinder/results";
import Steps from "../../components/landing/search-on-tinder/steps";
import RealStories from "../../components/landing/search-on-tinder/real-stories.vue";
import Featured from "../../components/landing/search-on-tinder/featured";
import Mission from "../../components/landing/search-on-tinder/mission";
import AlreadyUsing from "../../components/landing/search-on-tinder/already-using";
import Comments from "../../components/landing/search-on-tinder/comments.vue";
import Overcoming from "../../components/landing/search-on-tinder/overcoming";
import Faq from "../../components/landing/search-on-tinder/faq";
import QuotesBlockKnowledge from "../../components/landing/search-on-tinder/quotes-block-knowledge";
import Navigation from '../../components/Navigation.vue';
import FooterMain from '../../components/FooterMain.vue';

import isMob from "@/mixins/isMob";
import authorization from "@/mixins/authorization";
import { description } from "vue2-google-maps/docs/.vuepress/config";

export default {
  mixins: [isMob, authorization],
  mounted() {
    this.getUtm()
  },
  components: {
    FindPartner,
    blog,
    QuotesBlock,
    ServiceFor,
    HowWeDo,
    SitesScan,
    Waiting,
    Results,
    Steps,
    RealStories,
    Featured,
    Mission,
    AlreadyUsing,
    Comments,
    Overcoming,
    Faq,
    QuotesBlockKnowledge,
    Navigation,
    FooterMain,
  },
  head() {
    const title = 'Uncover Hidden Tinder Profiles | Catch A Cheater On Tinder Instantly';
    const description = 'Discover if your partner is secretly on Tinder. Our anonymous Tinder Blaster scans profiles instantly for $14.99. Protect your relationship with 100% discreet service. Start with Tinder cheater finder now!';

    return {
      title: title,
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { hid:'og:title', property: 'og:title', content: title },
        { hid: "description", name: "description", content: description },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Tinder profile lookup, search for a tinder profile, tinder account lookup, search Tinder profiles, how to find out if someone is on tinder, how to find if someone is on tinder'
        },
        { hid: "og:description", name: "og:description", content: description },
        { hid: 'og:image',  property: 'og:image', content: '/products/find-someone-cheating-online-for-free/og.png' },
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid:'og:site_name', property: 'og:site_name', content: 'ifindcheaters.com' },
        { hid: 'og:keywords', name: 'og:keywords', content: 'secret profile finder, search people on dating sites, search for someone on dating sites, search dating profiles, is my husband on dating sites, find hidden dating profiles, find my wife on dating sites, catch a cheating spouse, find spouse on dating sites, Catch cheating partner online, Online infidelity search, find out if my boyfriend or girlfriend is on dating sites, how to find spouse on dating sites, is my wife on dating sites or apps, free dating profiles search by email' }
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/products/search-on-tinder/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Products",
              "item": "https://ifindcheaters.com/products/"
            },{
              "@type": "ListItem",
              "position": 3,
              "name": "Tinder Blaster For Profiles Search"
            }]
          }
        },{
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "Tinder Blaster For Profiles Search",
            "sku": "007",
            "image": "https://ifindcheaters.com/img/logo.png",
            "description": "Catch your cheating spouse or partner on Tinder for just $14.99 with our Tinder Blaster. Grab now to get safe from cheaters. 100% Anonymous Service.",
            "brand": {
              "@type": "Brand",
              "name": "iFindCheaters"
            },
              "offers": {
              "@type": "Offer",
              "url": "https://ifindcheaters.com/products/search-on-tinder/",
              "priceCurrency": "USD",
              "price": "14.99",
              "priceValidUntil": "2022-04-10",
              "itemCondition": "https://schema.org/UsedCondition",
              "availability": "https://schema.org/InStock",
              "seller": {
              "@type": "Organization",
              "name": "iFindCheaters"
              }},
              "review": [{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "4",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Theo X"
              },
              "datePublished": "2022-02-10T14:05:30+00:00",
              "reviewBody": "We’d been living together for a few months when she started telling me she had all these business meetings in the city till late. Thanks to Tinder Blaster’s Tinder account search I found out those meetings weren’t for business."
            },{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Maddie F."
              },
            "datePublished": "2021-11-18T11:45:29+00:00",
            "reviewBody": "I did a search by name on Tinder and saw he was using the nickname I had given him as his Tinder username! Glad to let that one go."
            }],
              "aggregateRating": {
              "@type": "AggregateRating",
              "bestRating": "5",
              "ratingValue": "4.5",
              "reviewCount": "69"
              }
            }
          }
      ]
    }
  },
};
